import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { updateText } from '../../actions/DetailedFeedback'
import { processEditedData } from '../../actions/Edit'
import { fetchNewSamples } from '../../actions/AspireSamples'
import { markSectionVisited } from '../../actions/AspireFeedback'
import $ from 'jquery'
import classNames from 'classnames'
import _ from 'underscore'
import 'jquery-highlight'
import {
  notification,
  checkLinkedinUrlSanity,
  fetchCustomisation,
} from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import PersonalInformation from './PersonalInformation'
import ProfilePicture from './ProfilePicture'
import Headline from './Headline'
import Summary from './Summary'
import Experience from './Experience'
import Education from './Education'
import {
  fetchEditDynamicData,
  updateEditDynamicDataState,
} from '../../actions/AspireEditDynamicData'
import { Modal, ModalBody } from '@vmockinc/dashboard/Common/commonComps/Modal'
import FocusLock, { MoveFocusInside } from 'react-focus-lock'
import ErrorBoundary from '@vmockinc/dashboard/Common/commonComps/ErrorBoundary'

const timeOutMilliseconds = 2000

const sectionComponents = {
  'Personal Information': PersonalInformation,
  'Profile Picture': ProfilePicture,
  Headline: Headline,
  Summary: Summary,
  Experience: Experience,
  Education: Education,
}

const sectionUnderscore = {
  'Personal Information': 'personal_information',
  'Profile Picture': 'profile_picture',
  Headline: 'headline',
  Summary: 'summary',
  Experience: 'experience',
  Education: 'education',
}

const sectioNameToBackendVisitedSectioNameMapping = {
  'Personal Information': 'detailed_personal_info',
  'Profile Picture': 'detailed_profile_picture',
  Headline: 'detailed_headline',
  Summary: 'detailed_summary',
  Experience: 'detailed_experience',
  Education: 'detailed_education',
  'Summary Screen': 'summary',
  'Edit Personal Information': 'edit_personal_info',
  'Edit Profile Picture': 'edit_profile_picture',
  'Edit Headline': 'edit_headline',
  'Edit Summary': 'edit_summary',
  'Edit Experience': 'edit_experience',
  'Edit Education': 'edit_education',
}

const sectionEntities = {
  'Personal Information': ['name', 'profile_url'],
  'Profile Picture': [],
  Headline: ['text'],
  Summary: ['text'],
  Experience: ['title', 'company', 'from', 'to', 'text'],
  Education: [
    'school',
    'from',
    'to',
    'degree',
    'field_of_study',
    'grade',
    'activities_and_societies',
  ],
}

const sectionUnderscoreEntities = {
  personal_information: ['name', 'profile_url'],
  profile_picture: [],
  headline: ['text'],
  summary: ['text'],
  experience: ['title', 'company', 'from', 'to', 'text'],
  education: [
    'school',
    'from',
    'to',
    'degree',
    'field_of_study',
    'grade',
    'activities_and_societies',
  ],
}

export const charCountLimit = {
  personal_information: {
    name: 100,
  },
  headline: {
    text: 220,
  },
  summary: {
    text: 2600,
  },
  experience: {
    company: 100,
    title: 100,
    text: 2000,
  },
  education: {
    school: 150,
    degree: 100,
    field_of_study: 100,
    activities_and_societies: 500,
  },
  volunteer_experience: {
    title: 100,
    text: 2000,
  },
  projects: {
    title: 255,
    text: 2000,
  },
  publications: {
    title: 255,
    text: 2000,
  },
}

class EditSection extends Component {
  constructor() {
    super()
    this.state = {
      resetLanguageHelp: false,
      sectionWiseTextEditable: {},
      sectionsEntitiesToHighlight: {},
      highlightableDivWords: [],
      keyboardEscape: true,
      idealCharLimitReachedShown: false,
    }

    this.handleOnChangeData = this.handleOnChangeData.bind(this)
    this.handleOnChangePicture = this.handleOnChangePicture.bind(this)
    this.handleUndoData = this.handleUndoData.bind(this)
    this.unhighlightAll = this.unhighlightAll.bind(this)
    this.highlightEntityText = this.highlightEntityText.bind(this)
    this.underlineEntitySpellError = this.underlineEntitySpellError.bind(this)
    this.handleSaveChanges = this.handleSaveChanges.bind(this)
    this.languageHelpReset = this.languageHelpReset.bind(this)

    this.sectionWiseTextEditable = {}
    this.sectionsEntitiesToHighlight = {}
    this.highlightableDivWords = []
    this.timeScreenStart = 0
    this.timeEditingStart = 0
    this.toggleKeyboardFunctionality =
      this.toggleKeyboardFunctionality.bind(this)
    this.setIdealCharLimitReachedShown = this.setIdealCharLimitReachedShown.bind(this)

    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 3000, true)
    this.sendTrackingDataDebounceSave = _.debounce(sendTrackingData, 2000, true)
    this.checkVisitedSection = this.checkVisitedSection.bind(this)
    this.checkVisitedSectionDebounce = _.debounce(
      this.checkVisitedSection,
      1000,
      true
    )
  }

  UNSAFE_componentWillMount() {
    this.addEditDataToState(this.props)
    const { sectionName, currentIndex } = this.props

    if (_.isString(currentIndex) && currentIndex.substr(-4) === '_new') return
    this.handleUndoData(sectionUnderscore[sectionName], currentIndex)
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      updateEditSection,
      editSectionUpdated,
      detailedFeedbackUi,
      fetchId,
      fetchNewSamples,
      sectionWiseText,
      newSubSection,
      updateText,
    } = nextProps
    let sectionName = detailedFeedbackUi.section
    if (updateEditSection == true) {
      let currentIndex = detailedFeedbackUi[sectionName].currentIndex

      if (_.isEmpty(sectionWiseText[sectionUnderscore[sectionName]])) {
        currentIndex = this.props.currentSection + '_new'
      }
      updateText({
        updateKeys: [
          ['isEditOpen'],
          ['currentEditSection'],
          ['currentEditSectionIndex'],
        ],
        data: {
          isEditOpen: true,
          currentEditSection: sectionName,
          currentEditSectionIndex: currentIndex,
        },
      })

      let timeEditingStart = new Date()
      this.timeEditingStart = timeEditingStart.getTime()

      editSectionUpdated()
      this.addEditDataToState(nextProps)
    }

    if (
      updateEditSection === true &&
      !_.isEmpty(sectionWiseText[sectionUnderscore[sectionName]])
    ) {
      this.props.changeNewSubSectionValue(false)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    for (let i in this.state.highlightableDivWords) {
      $(this.state.highlightableDivWords[i][0]).highlight(
        this.state.highlightableDivWords[i][1],
        {
          wordsOnly: true,
          wordsBoundaryStart: '(?:[\\b\\W]|^)',
          wordsBoundaryEnd: '(?:[\\b\\W]|$)',
        }
      )
    }
    const { sectionName, currentIndex, fetchNewSamples, fetchId } = this.props
    if (!prevProps.saveChanges && this.props.saveChanges) {
      this.props.syncSectionTextEditable(this.sectionWiseTextEditable)
      this.props.changeSaveChangesState(false)
      this.props.handleSaveChanges()
    }
  }

  checkVisitedSection(currentSectionName) {
    let visitedSectionModuleName =
      sectioNameToBackendVisitedSectioNameMapping[currentSectionName]
    if (this.props.visited_sections[visitedSectionModuleName] == 0) {
      this.props.markSectionVisited(visitedSectionModuleName)
    }
  }

  componentWillUnmount() {
    const { updateText, sectionName, currentIndex } = this.props
    let timeScreenEnd = new Date()
    let timeScreenSpent =
      (timeScreenEnd.getTime() - this.timeScreenStart) / 1000
    if (timeScreenSpent > 1) {
      let jsonObjectForTracking = {
        eventLabel: 'screen_time',
        time: timeScreenSpent,
      }
      sendTrackingData(
        'event',
        'aspire_edit_screen',
        'time',
        JSON.stringify(jsonObjectForTracking)
      )
    }

    if (_.isString(currentIndex) && currentIndex.substr(-4) === '_new') {
      if (
        this.sectionWiseTextEditable.hasOwnProperty(
          sectionUnderscore[sectionName]
        ) &&
        this.sectionWiseTextEditable[
          sectionUnderscore[sectionName]
        ].hasOwnProperty(currentIndex)
      ) {
        this.sectionWiseTextEditable[sectionUnderscore[sectionName]] = _.omit(
          this.sectionWiseTextEditable[sectionUnderscore[sectionName]],
          currentIndex
        )
      }
    }

    updateText({
      updateKeys: [
        ['sectionWiseTextEditable'],
        ['sectionsEntitiesToHighlight'],
      ],
      data: {
        sectionWiseTextEditable: this.sectionWiseTextEditable,
        sectionsEntitiesToHighlight: this.sectionsEntitiesToHighlight,
      },
    })
  }

  addEditDataToState(props) {
    let {
      sectionWiseTextEditable,
      sectionName,
      currentIndex,
      updateEditSection,
      updateText,
    } = props
    if (updateEditSection == true && sectionName.substr(-4) == '_new') {
      return
    }

    let sectionUnderscoreName = sectionUnderscore[sectionName]
    if (
      !sectionWiseTextEditable[sectionUnderscoreName].hasOwnProperty(
        currentIndex
      )
    ) {
      sectionWiseTextEditable[sectionUnderscoreName][currentIndex] = {}
      for (let i in sectionEntities[sectionName]) {
        sectionWiseTextEditable[sectionUnderscoreName][currentIndex][
          sectionEntities[sectionName][i]
        ] = ''
      }
    }
    this.sectionWiseTextEditable = sectionWiseTextEditable
    this.sectionsEntitiesToHighlight = props.sectionsEntitiesToHighlight
    updateText({
      updateKeys: [['sectionWiseTextEditable']],
      data: {
        sectionWiseTextEditable: sectionWiseTextEditable,
      },
    })
    this.setState({
      resetLanguageHelp: true,
      sectionWiseTextEditable: sectionWiseTextEditable,
      sectionsEntitiesToHighlight: props.sectionsEntitiesToHighlight,
    })
  }

  componentDidMount() {
    let timeScreenStart = new Date()
    this.timeScreenStart = timeScreenStart.getTime()
    this.timeEditingStart = timeScreenStart.getTime()

    let currentSectionName = 'Edit ' + this.props.sectionName
    this.checkVisitedSectionDebounce(currentSectionName)
  }


  handleUndoData(sectionUnderscoreName, currentIndex) {
    let sectionWiseTextEditable = $.extend(
      true,
      {},
      this.sectionWiseTextEditable
    )
    const { sectionWiseTextStatic, updateText } = this.props

    if (
      !sectionWiseTextStatic[sectionUnderscoreName].hasOwnProperty(currentIndex)
    ) {
      sectionWiseTextEditable[sectionUnderscoreName][currentIndex] = {}
      for (let i in sectionUnderscoreEntities[sectionUnderscoreName]) {
        sectionWiseTextEditable[sectionUnderscoreName][currentIndex][
          sectionUnderscoreEntities[sectionUnderscoreName][i]
        ] = ''
      }
    } else {
      sectionWiseTextEditable[sectionUnderscoreName][currentIndex] =
        sectionWiseTextStatic[sectionUnderscoreName][currentIndex]
    }

    this.sectionWiseTextEditable = sectionWiseTextEditable
    updateText({
      updateKeys: [['sectionWiseTextEditable']],
      data: {
        sectionWiseTextEditable: sectionWiseTextEditable,
      },
    })
    this.setState({ sectionWiseTextEditable: sectionWiseTextEditable })
  }

  languageHelpReset() {
    this.setState({ resetLanguageHelp: false })
  }

  unhighlightAll() {
    for (let i in this.state.highlightableDivWords) {
      $(this.state.highlightableDivWords[i][0]).unhighlight()
    }
    this.setState({ highlightableDivWords: [] })
    this.highlightableDivWords = []
  }

  underlineEntitySpellError() {
    if (
      this.sectionsEntitiesToHighlight[this.props.sectionName].hasOwnProperty(
        'language'
      ) &&
      this.sectionsEntitiesToHighlight[this.props.sectionName][
        'language'
      ].hasOwnProperty('spell_check') &&
      this.sectionsEntitiesToHighlight[this.props.sectionName]['language'][
        'spell_check'
      ].hasOwnProperty(this.props.currentIndex) &&
      this.sectionsEntitiesToHighlight[this.props.sectionName]['language'][
        'spell_check'
      ][this.props.currentIndex].hasOwnProperty('text')
    ) {
      for (let i in this.sectionsEntitiesToHighlight[this.props.sectionName][
        'language'
      ]['spell_check'][this.props.currentIndex]['text']) {
        let entity =
          this.sectionsEntitiesToHighlight[this.props.sectionName]['language'][
            'spell_check'
          ][this.props.currentIndex]['text'][i]['entity']
        let text =
          this.sectionsEntitiesToHighlight[this.props.sectionName]['language'][
            'spell_check'
          ][this.props.currentIndex]['text'][i]['text']
        $(
          '.' + sectionUnderscore[this.props.sectionName] + '-entity-' + entity
        ).highlight(text, {
          className: 'underline-spell-error',
          wordsOnly: true,
          wordsBoundaryStart: '(?:[\\b\\W]|^)',
          wordsBoundaryEnd: '(?:[\\b\\W]|$)',
        })
      }
    }
  }

  cleanWord(word) {
    const { isUKEnable, intl } = this.props
    if (_.isUndefined(word)) {
      return ''
    }
    let map = {
      por: intl.formatMessage({ id: "aspire.editSection.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      job_industry: intl.formatMessage({ id: "aspire.editSection.industry", defaultMessage: "Industry" }),
      degree_category: intl.formatMessage({ id: "aspire.editSection.degree", defaultMessage: "Degree" }),
      'fp&a': intl.formatMessage({ id: "aspire.editSection.fpAndA", defaultMessage: "FP&A" }),
      job_role: intl.formatMessage({ id: "aspire.editSection.jobRole", defaultMessage: "Job Role" }),
      job_function: intl.formatMessage({ id: "aspire.editSection.jobFunction", defaultMessage: "Job Function" }),
      projects: intl.formatMessage({ id: "aspire.editSection.projects", defaultMessage: "Projects" }),
      concentration: intl.formatMessage({ id: "aspire.editSection.concentration", defaultMessage: "Concentration" }),
      schools: intl.formatMessage({ id: "aspire.editSection.schoolOrUniversity", defaultMessage: "School/University" }),
      clubs: intl.formatMessage({ id: "aspire.editSection.clubOrSociety", defaultMessage: "Club/Society" }),
      awards: intl.formatMessage({ id: "aspire.editSection.awards", defaultMessage: "Awards" }),
      competitions: intl.formatMessage({ id: "aspire.editSection.competitions", defaultMessage: "Competitions" }),
      certifications: intl.formatMessage({ id: "aspire.editSection.certifications", defaultMessage: "Certifications" }),
      goals: intl.formatMessage({ id: "aspire.editSection.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
      company_name: isUKEnable
        ? intl.formatMessage({ id: "aspire.editSection.companyOrganisation", defaultMessage: "Company/Organisation" })
        : intl.formatMessage({ id: "aspire.editSection.companyOrganization", defaultMessage: "Company/Organization" }),
      contact_information: intl.formatMessage({ id: "aspire.editSection.contactInformation", defaultMessage: "Contact Information" }),
      coursework: intl.formatMessage({ id: "aspire.editSection.coursework", defaultMessage: "Coursework" }),
      competitive_exams: intl.formatMessage({ id: "aspire.editSection.competitiveExam", defaultMessage: "Competitive Exam" }),
      volunteer_experience: intl.formatMessage({ id: "aspire.editSection.volunteerExperience", defaultMessage: "Volunteer Experience" }),
    }

    if (map.hasOwnProperty(word)) {
      return map[word]
    }
    let frags = word.split(/[ _]+/)
    for (let i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
    }
    return frags.join(' ')
  }

  highlightEntityText(submodule, buttonLabel, type, finalHighlightTexts = []) {
    const {
      dataSkills,
      dataContent,
      dataLanguage,
      dataImpact,
      dataRephraseWords,
    } = this.props
    let texts = {}
    let highlightableDivWords = []
    if (type == 'static') {
      if (submodule == 'categories') {
        texts =
          this.sectionsEntitiesToHighlight[this.props.sectionName][submodule][
            this.props.currentIndex
          ][buttonLabel].text
      } else if (submodule == 'skills') {
        if (this.props.sectionName == 'Headline') {
          texts = [{ entity: 'text', text: buttonLabel }]
        } else {
          texts =
            this.sectionsEntitiesToHighlight[this.props.sectionName][submodule][
              'relevant_skills_present'
            ][this.props.currentIndex][buttonLabel]
        }
      } else if (submodule == 'language') {
        texts =
          this.sectionsEntitiesToHighlight[this.props.sectionName][submodule][
            buttonLabel
          ][this.props.currentIndex].text
      } else if (submodule == 'impact') {
        texts =
          this.sectionsEntitiesToHighlight[this.props.sectionName][submodule][
            buttonLabel
          ][this.props.currentIndex].text
      }
      else if (submodule == 'presentation') {
        texts =
          this.sectionsEntitiesToHighlight[this.props.sectionName][submodule][buttonLabel][
            this.props.currentIndex
          ].text
      }
    } else {
      if (submodule == 'categories') {
        texts = finalHighlightTexts
      } else if (submodule == 'skills') {
        texts = finalHighlightTexts
      } else if (submodule == 'language') {
        texts = dataLanguage[buttonLabel]['highlightValues']
      } else if (submodule == 'impact') {
        texts = dataImpact[buttonLabel]['highlightValues']
      } else if (submodule == 'rephrase_words') {
        texts = dataRephraseWords[buttonLabel]['highlightValues']
      }
    }
    let textArray = []
    for (let i in texts) {
      highlightableDivWords.push([
        '.' +
          sectionUnderscore[this.props.sectionName] +
          '-entity-' +
          texts[i]['entity'],
        texts[i]['text'],
        submodule,
      ])
      let escapedText = texts[i]['text'].replace(/\.$/, '')
      escapedText = escapedText
        .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      // escapedText = '([\\b\\W]|^)' + escapedText + '([\\b\\W]|$)'
      // escapedText = '(?!\\n[\\b\\W]|^)*' + escapedText + '(?=[\\b\\W]|$)'  anmol
      // escapedText = '(?!\\n[\\W]|^)*\\b' + escapedText + '(?=[\\b\\W]|$)'
      escapedText =
        '(?!\\n[\\W]|^)*(\\b(?=[\\w])|)' + escapedText + '(?=[\\b\\W]|$)'
      textArray.push(escapedText)
    }
    let regexString = ''
    if (!_.isEmpty(texts)) {
      regexString = new RegExp(textArray.join('|'), 'ig')
    }

    this.highlightableDivWords = [regexString, submodule]

    this.setState({ highlightableDivWords: highlightableDivWords })

    if (!_.isUndefined(this.interval)) {
      clearInterval(this.interval)
    }

    this.interval = setInterval(() => this.checkIfHighlighDone(), 500)

    setTimeout(() => {
      clearInterval(this.interval)
    }, 2000)
  }

  checkIfHighlighDone() {
    let ele = $('.hwt-container textarea')
    let ele1 = $('.hwt-highlights mark:first')

    if (!_.isUndefined(ele[0]) && !_.isUndefined(ele1[0])) {
      $('.hwt-container textarea').animate(
        {
          scrollTop:
            $('.hwt-container textarea').scrollTop() +
            $('.hwt-highlights mark:first').offset().top -
            $('.hwt-container textarea').offset().top,
        },
        {
          specialEasing: {
            width: 'linear',
            height: 'easeOutBounce',
          },
        }
      )

      clearInterval(this.interval)
    }
  }

  handleOnChangeData(sectionUnderscoreName, currentIndex, entity, data) {
    const { updateText, intl } = this.props
    const { idealCharLimitReachedShown } = this.state
    if (sectionUnderscoreName === 'personal_information') {
      if (entity === 'profile_url') {
        if (data.length > 58 && idealCharLimitReachedShown === false) {
          let idealCharLimitReachedMessage = intl.formatMessage({ id: "aspire.editSection.idealProfileUrl", defaultMessage: "Try shortening your custom URL, so it's easy to use" })
          notification(idealCharLimitReachedMessage, 'information', timeOutMilliseconds)
          this.setIdealCharLimitReachedShown(true)
        } else if (data.length <= 58 && idealCharLimitReachedShown === true) {
          this.setIdealCharLimitReachedShown(false)
        }

        if (data.length > 128) {
          let errorMessage = intl.formatMessage({ id: "aspire.editSection.maxProfileUrl", defaultMessage: "Maximum limit of 100 characters reached" })
          notification(errorMessage, 'error', timeOutMilliseconds)
        }

        let testStr = data
        let param = testStr.slice(28)
        let valid = checkLinkedinUrlSanity(param)

        if (!valid) {
          let errorMessage = intl.formatMessage({ id: "aspire.editSection.invalidProfileUrl", defaultMessage: "Entered character not allowed in this field." })
          notification(errorMessage, 'error', timeOutMilliseconds)
          return false
        }
      }
    }

    if (
      charCountLimit.hasOwnProperty(sectionUnderscoreName) &&
      charCountLimit[sectionUnderscoreName].hasOwnProperty(entity) &&
      charCountLimit[sectionUnderscoreName][entity] < data.length
    ) {
      let errorMessage = intl.formatMessage(
        { id: "aspire.editSection.maxCharLimit", defaultMessage: "Maximum limit of {limit} characters reached" },
        { limit: charCountLimit[sectionUnderscoreName][entity] }
      )
      notification(errorMessage, 'error', timeOutMilliseconds)
    }
    let sectionWiseTextEditable = $.extend(
      true,
      {},
      this.props.sectionWiseTextEditable
    )
    //sectionWiseTextEditable[sectionUnderscoreName][currentIndex][entity] = data.substr(0,charCountLimit[sectionUnderscoreName][entity])
    sectionWiseTextEditable[sectionUnderscoreName][currentIndex][entity] = data
    this.sectionWiseTextEditable = sectionWiseTextEditable
    updateText({
      updateKeys: [['sectionWiseTextEditable']],
      data: {
        sectionWiseTextEditable: sectionWiseTextEditable,
      },
    })
    this.setState({ sectionWiseTextEditable: sectionWiseTextEditable })
    return true
  }

  handleOnChangePicture(currentIndex, imageData) {
    const { updateText } = this.props
    let sectionWiseTextEditable = $.extend(
      true,
      {},
      this.props.sectionWiseTextEditable
    )
    
    // Ensure profile_picture array exists and has element at currentIndex
    if (!sectionWiseTextEditable['profile_picture']) {
      sectionWiseTextEditable['profile_picture'] = []
    }
    if (!sectionWiseTextEditable['profile_picture'][currentIndex]) {
      sectionWiseTextEditable['profile_picture'][currentIndex] = {}
    }
    
    sectionWiseTextEditable['profile_picture'][currentIndex]['picture_url'] =
      imageData.url
    sectionWiseTextEditable['profile_picture'][currentIndex]['picture_string'] =
      imageData.string
    sectionWiseTextEditable['profile_picture'][currentIndex][
      'original_string'
    ] = imageData.original_image_string
    const parameters = [
      'face_frame_ratio',
      'background',
      'foreground',
      'resolution',
      'symmetry',
      'face_body_ratio',
      'professional_clothes',
      'pupil',
      'smile',
    ]
    for (let i in parameters) {
      if (
        imageData.hasOwnProperty(parameters[i]) &&
        !_.isNull(imageData[parameters[i]]) &&
        sectionWiseTextEditable['profile_picture'][currentIndex]
      ) {
        sectionWiseTextEditable['profile_picture'][currentIndex][
          parameters[i]
        ] = imageData[parameters[i]]
      }
    }
    this.sectionWiseTextEditable = sectionWiseTextEditable
    updateText({
      updateKeys: [['sectionWiseTextEditable']],
      data: {
        sectionWiseTextEditable: sectionWiseTextEditable,
      },
    })
    this.setState({ sectionWiseTextEditable: sectionWiseTextEditable })
  }

  handleSaveChanges() {
    this.props.syncSectionTextEditable(this.sectionWiseTextEditable)
    this.props.handleSaveChanges()
  }

  toggleKeyboardFunctionality(boolValue) {
    this.setState({ keyboardEscape: boolValue })
  }

  setIdealCharLimitReachedShown(value = true) {
    this.setState({ idealCharLimitReachedShown: value })
  }

  render() {
    const {
      has_pdf,
      fetchId,
      show,
      sectionName,
      currentIndex,
      newSubSection,
      derivedSkills,
      sectionWiseText,
      sectionsPerSkill,
      resumeSkillsInLinkedin,
      feedback,
      sectionWiseTextStatic,
      showEditModal,
      hideEditModal,
      updateEditSection,
      allCapsResume,
      allSmallResume,
      normalResume,
      has_resume,
      focusDisable,
      uploadingEditedData,
      showConfirmDeleteModal,
      addNewSection,
      showLogModal,
      intl, // Added intl for formatted messages
    } = this.props
    const { keyboardEscape } = this.state
    const CurrentEditComponent = sectionComponents[sectionName]

    let dialogClassName = 'modal-width-small'
    let className = 'as-edit-modal-scrollable'

    if (sectionName == 'Personal Information') {
      dialogClassName = 'personal-information-modal'
    } else if (sectionName == 'Profile Picture') {
      dialogClassName = `${
        keyboardEscape ? '' : 'display-none'
      } profile-picture-modal`
    } else if (sectionName == 'Headline') {
      dialogClassName = 'headline-modal'
    } else if (sectionName == 'Education') {
      dialogClassName = 'education-modal'
    } else if (sectionName == 'Experience') {
      dialogClassName = 'experience-modal'
    } else if (sectionName == 'Summary') {
      dialogClassName = 'summary-modal'
    }

    let sectionUnderscoreName = sectionUnderscore[sectionName]
    return (
      <div
        className={`as-edit-screen ${
          sectionName === 'Profile Picture' && 'as-edit-screen-profile-pic'
        }`}
      >
        {sectionName !== 'Profile Picture' ? (
          <ErrorBoundary product="aspire" component={`Edit-${sectionName}`}>
            <CurrentEditComponent
              tabIndex={1}
              has_pdf={has_pdf}
              fetchId={fetchId}
              currentIndex={currentIndex}
              newSubSection={newSubSection}
              derivedSkills={derivedSkills}
              sectionWiseText={sectionWiseText}
              sectionWiseTextEditable={
                this.props.sectionWiseTextEditable[
                  sectionUnderscore[sectionName]
                ]
              }
              sectionWiseTextStatic={
                sectionWiseTextStatic[sectionUnderscore[sectionName]]
              }
              resumeSkillsInLinkedin={resumeSkillsInLinkedin}
              resetLanguageHelp={this.state.resetLanguageHelp}
              languageHelpReset={this.languageHelpReset}
              underlineEntitySpellError={this.underlineEntitySpellError}
              highlightEntityText={this.highlightEntityText}
              sectionsEntitiesToHighlight={this.sectionsEntitiesToHighlight}
              unhighlightAll={this.unhighlightAll}
              sectionsPerSkill={sectionsPerSkill}
              feedback={feedback}
              hideEditModal={hideEditModal}
              showConfirmDeleteModal={showConfirmDeleteModal}
              addNewSection={addNewSection}
              showLogModal={showLogModal}
              handleOnChangeData={this.handleOnChangeData}
              handleOnChangePicture={this.handleOnChangePicture}
              handleUndoData={this.handleUndoData}
              handleSaveChanges={this.handleSaveChanges}
              updateEditSection={updateEditSection}
              allCapsResume={allCapsResume}
              allSmallResume={allSmallResume}
              normalResume={normalResume}
              highlightableDivWords={this.props.highlightableEditDivWords}
              has_resume={has_resume}
              toggleKeyboardFunctionality={this.toggleKeyboardFunctionality}
              focusDisable={focusDisable}
              uploadingEditedData={uploadingEditedData}
            />
          </ErrorBoundary>
        ) : (
          <Modal
            keyboard={keyboardEscape}
            className="profile-picture-edit-modal"
            isOpen={show}
            onRequestHide={() =>
              hideEditModal(
                sectionUnderscoreName,
                currentIndex,
                this.props.sectionWiseTextEditable[sectionUnderscoreName],
                sectionWiseTextStatic[sectionUnderscoreName]
              )
            }
          >
            <ModalBody tabIndex={-1}>
              <ErrorBoundary product="aspire" component={`Edit-${sectionName}`}>
                <CurrentEditComponent
                  tabIndex={1}
                  has_pdf={has_pdf}
                  fetchId={fetchId}
                  currentIndex={currentIndex}
                  newSubSection={newSubSection}
                  derivedSkills={derivedSkills}
                  sectionWiseText={sectionWiseText}
                  sectionWiseTextEditable={
                    this.props.sectionWiseTextEditable[
                      sectionUnderscore[sectionName]
                    ]
                  }
                  sectionWiseTextStatic={
                    sectionWiseTextStatic[sectionUnderscore[sectionName]]
                  }
                  resumeSkillsInLinkedin={resumeSkillsInLinkedin}
                  resetLanguageHelp={this.state.resetLanguageHelp}
                  languageHelpReset={this.languageHelpReset}
                  underlineEntitySpellError={this.underlineEntitySpellError}
                  highlightEntityText={this.highlightEntityText}
                  sectionsEntitiesToHighlight={this.sectionsEntitiesToHighlight}
                  unhighlightAll={this.unhighlightAll}
                  sectionsPerSkill={sectionsPerSkill}
                  feedback={feedback}
                  hideEditModal={hideEditModal}
                  showLogModal={showLogModal}
                  handleOnChangeData={this.handleOnChangeData}
                  handleOnChangePicture={this.handleOnChangePicture}
                  handleUndoData={this.handleUndoData}
                  handleSaveChanges={this.handleSaveChanges}
                  updateEditSection={updateEditSection}
                  allCapsResume={allCapsResume}
                  allSmallResume={allSmallResume}
                  normalResume={normalResume}
                  highlightableDivWords={this.highlightableDivWords}
                  has_resume={has_resume}
                  toggleKeyboardFunctionality={this.toggleKeyboardFunctionality}
                  focusDisable={focusDisable}
                  uploadingEditedData={uploadingEditedData}
                />
              </ErrorBoundary>
            </ModalBody>
          </Modal>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    edited_section_mapping:
      state.aspireFeedbackData.data.edited_section_mapping,
    sectionWiseTextStatic: state.detailedFeedbackUi.sectionWiseTextStatic,
    has_pdf: state.aspireFeedbackData.has_pdf,
    allCapsResume: state.aspireFeedbackData.allCapsResume,
    allSmallResume: state.aspireFeedbackData.allSmallResume,
    normalResume: state.aspireFeedbackData.normalResume,
    detailedFeedbackUi: state.detailedFeedbackUi,
    visited_sections: state.aspireFeedbackData.visited_sections,
    hasResume: state.aspireFeedbackData.has_resume,
    dataSkills: state.aspireEditDynamicData.dataSkills,
    dataContent: state.aspireEditDynamicData.dataContent,
    dataLanguage: state.aspireEditDynamicData.dataLanguage,
    dataImpact: state.aspireEditDynamicData.dataImpact,
    dataRephraseWords: state.aspireEditDynamicData.dataRephraseWords,
    isUKEnable: state.aspireFeedbackData.ukEnglish,
    uploadingEditedData: state.editData.uploading_edited_data,
    sectionWiseTextEditable: state.detailedFeedbackUi.sectionWiseTextEditable,
  }
}

export default connect(mapStateToProps, {
  updateText,
  processEditedData,
  fetchNewSamples,
  markSectionVisited,
  fetchEditDynamicData,
})(injectIntl(EditSection))
